module.exports = __webpack_public_path__ + "static/prighter-certificate-eu-7c0b0bead1821e86115914626e15d079.png";